import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/layout/index.vue'

Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/',
    component: Home,
    meta: {
      title: '首页'
    },
    redirect: '/home',
    children: [
      {
        path: 'home',
        component: () => import('@/components/main/index'),
        name: 'home',
        meta: {
          title: '网站首页',
        }
      },
      {
        path: 'about',
        component: () => import('@/components/aboutLayout/index'),
        name: 'About',
        redirect: 'about/home',
        meta: {
          title: '关于我们',
          English: 'ABOUT US'
        },
        children: [
          {
            fullPath: '/about/home',
            path: 'home',
            component: () => import('@/components/about/index'),
            name: 'home',
            meta: {
              title: '公司简介',
            }
          },
          {
            fullPath: '/about/honor',
            path: 'honor',
            component: () => import('@/components/honor/index'),
            name: 'Honor',
            meta: {
              title: '品牌荣誉',
            }
          },
          {
            fullPath: '/about/environment',
            path: 'environment',
            component: () => import('@/components/environment/index'),
            name: 'Environment',
            meta: {
              title: '公司环境',
            }
          },
          {
            fullPath: '/about/control',
            path: 'control',
            component: () => import('@/components/control/index'),
            name: 'Control',
            meta: {
              title: '源头控制',
            }
          }, {
            fullPath: '/about/partition',
            path: 'partition',
            component: () => import('@/components/partition/index'),
            name: 'Partition',
            meta: {
              title: '分区存放',
            }
          }, {
            fullPath: '/about/distribution',
            path: 'distribution',
            component: () => import('@/components/distribution/index'),
            name: 'Distribution',
            meta: {
              title: '专业配送',
            }
          }
        ]
      },
      {
        path: 'distribution',
        component: () => import('@/components/distributionLayout/index'),
        name: 'Distribution',
        redirect: 'distribution/home',
        meta: {
          title: '产品配送',
          English: 'DISTRIBUTION'
        },
        children: [
          {
            fullPath: '/distribution/home',
            path: 'home',
            component: () => import('@/components/distributionmain/index'),
            name: 'home',
            meta: {
              title: '蔬菜配送',
            }
          },
          {
            fullPath: '/distribution/oil',
            path: 'oil',
            component: () => import('@/components/oil/index'),
            name: 'Oil',
            meta: {
              title: '粮油配送',
            }
          }, {
            fullPath: '/distribution/meat',
            path: 'meat',
            component: () => import('@/components/meat/index'),
            name: 'Meat',
            meta: {
              title: '鲜肉配送',
            }
          },
          {
            fullPath: '/distribution/aquatic',
            path: 'aquatic',
            component: () => import('@/components/aquatic/index'),
            name: 'Aquatic',
            meta: {
              title: '水产配送',
            }
          },
          {
            fullPath: '/distribution/frozenMeat',
            path: 'frozenMeat',
            component: () => import('@/components/frozenMeat/index'),
            name: 'FrozenMeat',
            meta: {
              title: '冻肉配送',
            }
          }, {
            fullPath: '/distribution/vegetable',
            path: 'vegetable',
            component: () => import('@/components/vegetable/index'),
            name: 'Vegetable',
            meta: {
              title: '干菜配送',
            }
          }, {
            fullPath: '/distribution/seasoning',
            path: 'seasoning',
            component: () => import('@/components/seasoning/index'),
            name: 'Seasoning',
            meta: {
              title: '调料配送',
            }
          }
        ]
      },
      {
        path: 'contracted',
        component: () => import('@/components/dining/index'),
        name: 'Contracted',
        meta: {
          title: '食堂承包',
        }
      },
      {
        path: 'case',
        component: () => import('@/components/case/index'),
        name: 'Case',
        meta: {
          title: '客户案例',
        }
      },
      {
        path: 'contact',
        component: () => import('@/components/contact/index'),
        name: 'Contact',
        meta: {
          title: '联系我们',
          noCache: true
        },
      }
    ]
  }
]

export default new Router({
  routes: constantRouterMap
})

export const asyncRouterMap = [
]



// WEBPACK FOOTER //
// ./src/router/index.js